export const toggleColumnFilterValue = (
  columnFilters,
  column,
  value
) => {
  const current = columnFilters[column] || []

  return current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value]
}
